import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import commonEn from './locales/en/common.js'
import packEn from './locales/en/pack.js'
import commonDe from './locales/de/common.js'
import packDe from './locales/de/pack.js'

export const supportedLanguages = Object.freeze(['en', 'de'])
export const languageStorageKey = 'ncg:language'

function detectLanguage() {
  if (typeof window === 'undefined') return 'en'
  const stored = window.localStorage.getItem(languageStorageKey)
  if (supportedLanguages.includes(stored)) return stored
  const browserLanguage = window.navigator.language?.split('-')[0]
  return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en'
}

const resources = {
  en: { common: commonEn, pack: packEn },
  de: { common: commonDe, pack: packDe },
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: 'en',
  supportedLngs: supportedLanguages,
  defaultNS: 'common',
  ns: ['common', 'pack'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  returnEmptyString: false,
})

function applyLanguage(language) {
  if (typeof document !== 'undefined') document.documentElement.lang = language
  if (typeof window !== 'undefined') window.localStorage.setItem(languageStorageKey, language)
}

applyLanguage(i18n.resolvedLanguage ?? i18n.language)
i18n.on('languageChanged', applyLanguage)

export { resources }
export default i18n
